/**
 * Reader-submitted "vibe" tags — no such community-tagging system exists
 * yet anywhere in the app (unlike genres/subjects, which come from the
 * catalog/Open Library), so this is the seed pool communityBookData.js
 * deterministically samples from per book.
 */
export const TAG_POOL = [
  'slow burn', 'found family', 'plot twist', 'cozy', 'heartbreaking',
  'unputdownable', 'character-driven', 'atmospheric', 'dark academia',
  'morally grey', 'enemies to lovers', 'chosen one', 'multiple povs',
  'unreliable narrator', 'beautiful prose', 'fast-paced', 'emotional',
  'strong FMC', 'slow start', 'bittersweet ending', 'comfort read',
  'thought-provoking', 'binge-worthy', 'quiet devastation',
];
